module.exports = __webpack_public_path__ + "static/media/img04.1cb5a920.webp";